import { thunk, action } from 'easy-peasy'
import _ from 'lodash'

import { getOrganizationFilterListApi } from 'services/filter/organization'
import { getRoleFilterListApi } from 'services/filter/role'
import { getProfileFilterListApi } from 'services/filter/profile'
import { getMenuFilterListApi } from 'services/filter/menu'
import { getGroupAttributeFilterListApi } from 'services/filter/groupAttribute'
import { getDataTypeFilterListApi } from 'services/filter/dataType'
import { getDictionaryFilterListApi } from 'services/filter/dictionary'
import { getDayFilterListApi } from 'services/filter/day'
import { getReportTypeAttributeFilterListApi } from 'services/filter/reportTypeAttribute'
import { getReportStatusFilterListApi } from 'services/filter/reportStatus'
import { getReportTypeFilterListApi } from 'services/filter/reportType'
import { getRiskLevelFilterListApi } from 'services/filter/riskLevel'
import { getImpactTypeFilterListApi } from 'services/filter/impactType'
import { getRiskOwnerFilterListApi } from 'services/filter/riskOwner'
import { getTaskStatusFilterListApi } from 'services/filter/taskStatus'

const initialState = {
  organizations: [],
  roles: [],
  profiles: [],
  menus: [],
  groupAttributes: [],
  dataTypes: [],
  dictionaries: [],
  days: [],
  reportTypeAttributes: [],
  reportStatuses: [],
  reportType: [],
  reportTypes: [],
  riskLevels: [],
  impactTypes: [],
  riskOwners: [],
  taskStatus: [],
}

const actions = {
  reset: action((state, payload) => {
    state = {
      ...initialState,
    }
  }),

  setOrganizations: action((state, payload) => {
    state.organizations = payload
  }),

  setRoles: action((state, payload) => {
    state.roles = payload
  }),

  setProfiles: action((state, payload) => {
    state.profiles = payload
  }),

  setMenus: action((state, payload) => {
    state.menus = payload
  }),

  setGroupAttributes: action((state, payload) => {
    state.groupAttributes = payload
  }),

  setDataTypes: action((state, payload) => {
    state.dataTypes = payload
  }),

  setDictionaries: action((state, payload) => {
    state.dictionaries = payload
  }),

  setDays: action((state, payload) => {
    state.days = payload
  }),

  setReportTypeAttributes: action((state, payload) => {
    state.reportTypeAttributes = payload
  }),

  setReportStatuses: action((state, payload) => {
    state.reportStatuses = payload
  }),

  setReportType: action((state, payload) => {
    state.reportType = payload
  }),

  setReportTypes: action((state, payload) => {
    state.reportTypes = payload
  }),

  setRiskLevels: action((state, payload) => {
    state.riskLevels = payload
  }),

  setImpactTypes: action((state, payload) => {
    state.impactTypes = payload
  }),

  setRiskOwners: action((state, payload) => {
    state.riskOwners = payload
  }),

  setTaskStatus: action((state, payload) => {
    state.taskStatus = payload
  }),
}

const thunks = {
  getOrganizations: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().organizations

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getOrganizationFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setOrganizations(itemsResult.data)
      }
    }
  }),

  getRoles: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().roles

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getRoleFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setRoles(itemsResult.data)
      }
    }
  }),

  getProfiles: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().profiles

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getProfileFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setProfiles(itemsResult.data)
      }
    }
  }),

  getMenus: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().menus

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getMenuFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setMenus(itemsResult.data)
      }
    }
  }),

  getGroupAttributes: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().groupAttributes

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getGroupAttributeFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setGroupAttributes(itemsResult.data)
      }
    }
  }),

  getDataTypes: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().dataTypes

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getDataTypeFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setDataTypes(itemsResult.data)
      }
    }
  }),

  getDictionaries: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().dictionaries

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getDictionaryFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setDictionaries(itemsResult.data)
      }
    }
  }),

  getDays: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().days

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getDayFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setDays(itemsResult.data)
      }
    }
  }),

  getReportTypeAttributes: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().reportTypeAttributes

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getReportTypeAttributeFilterListApi({})

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setReportTypeAttributes(itemsResult.data)
      }
    }
  }),

  getReportStatuses: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().reportStatuses

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getReportStatusFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setReportStatuses(itemsResult.data)
      }
    }
  }),

  getReportTypeThunk: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().reportType

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const { status, data } = await getReportTypeFilterListApi()

    if (status === 'success' && !_.isEmpty(data)) {
      actions.setReportType(data)
    }
  }),

  getTaskStatusThunk: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().taskStatus

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const { status, data } = await getTaskStatusFilterListApi()

    if (status === 'success' && !_.isEmpty(data)) {
      actions.setTaskStatus(data)
    }
  }),

  getReportTypes: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().reportTypes

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getReportTypeFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setReportTypes(itemsResult.data)
      }
    }
  }),

  getRiskLevels: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().riskLevels

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getRiskLevelFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setRiskLevels(itemsResult.data)
      }
    }
  }),

  getImpactTypes: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().impactTypes

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getImpactTypeFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setImpactTypes(itemsResult.data)
      }
    }
  }),

  getRiskOwners: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().riskOwners

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getRiskOwnerFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setRiskOwners(itemsResult.data)
      }
    }
  }),

  getTaskStatuses: thunk(async (actions, payload, { getState }) => {
    const oldItems = getState().taskStatuses

    if (!_.isEmpty(oldItems)) {
      if (!payload?.forceGet) {
        return
      }
    }

    const itemsResult = await getTaskStatusFilterListApi()

    if (itemsResult.status === 'success') {
      if (!_.isEmpty(itemsResult.data)) {
        actions.setTaskStatuses(itemsResult.data)
      }
    }
  }),
}

const model = {
  ...initialState,
  ...actions,
  ...thunks,
}

export default model
